export default "__VITE_ASSET__XpWrc_Se__"